import { RootState } from './../../app/store';
import { createSlice } from '@reduxjs/toolkit'
import { Color } from '@material-ui/lab';
import { alertProps, snackbarState } from './globalSnackbarTypes';

const initialState: snackbarState = {
    open: false,
    alertProps: {
        title: "",
        message: "",
        severity: "success" as Color,
        duration: 6000,
        isError: false,
        dateAndTime: "",
        requestUrl: "",
        statusCode: "",
        xRequestID: ""
    }


}

const globalSnackbarSlice = createSlice({
    name: "snackbar",
    initialState,
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        openSnackbar: (state, action) => {
            state.open = true;
            state.alertProps.title = action.payload.title;
            state.alertProps.message = action.payload.message;
            state.alertProps.severity = action.payload.severity;
            state.alertProps.duration = action.payload.duration;
            if (action.payload.severity == "error") {
                state.alertProps.isError = true;
            } else {
                state.alertProps.isError = false;
            }
            state.alertProps.dateAndTime = action.payload.dateAndTime;
            state.alertProps.requestUrl = action.payload.requestUrl;
            state.alertProps.statusCode = action.payload.statusCode;
            state.alertProps.xRequestID = action.payload.xRequestID;
            
              
 }

    }
});

export const {
    setOpen,
    openSnackbar
} = globalSnackbarSlice.actions

export const selectOpen = (state: RootState): boolean => state.snackbar.open;
export const selectAlertProps = (state: RootState): alertProps => state.snackbar.alertProps;
export const selectIsError = (state: RootState): boolean => state.snackbar.alertProps.isError;

export default globalSnackbarSlice.reducer